import { createHttpEndpoint } from '../../utils'

import type { GetPreparationTime } from './preparation-times.types'

/**
 * Get preparation time for a specific shipping category.
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/shipping-service-delivery-methods-api/definition#/delivery-methods/delivery_methods_v1_get_preparation_time}
 */
export const getPreparationTime = createHttpEndpoint<GetPreparationTime>({
  method: 'GET',
  operationId: 'getPreparationTime',
  path: '/bm/delivery-methods/v1/seller/:sellerId/preparation-time',
})
